module.exports = __webpack_public_path__ + "img/overview-clipmaker.d50cc280.png";